module.exports = __webpack_public_path__ + "img/工具大礼包剃须刀.f96fb50a.png";